<ng-template #trainNameTemplate let-train="train" let-last="last">
  @if (train.type == 'multi' && train.subSegments) {
    @for (t of train.subSegments; track t; let last = $last) {
      <ng-container
        [ngTemplateOutlet]='trainNameTemplate'
        [ngTemplateOutletContext]='{last:last, train:t}'
      ></ng-container>
    }
  }
  @if (train.type != 'multi') {
    <div class="train-name-container">
      <div class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
        @if (trainTypeImages[train.type]) {
          <img [matTooltip]="train.type" [src]="trainTypeImages[train.type]" class="train-icon"/>
        }
        <small class="train-title">{{train.name}}</small>
      </div>
      <!--<span class="train-subtitle">{{subTitle(train)}}</span>-->
    </div>
  }
  @if (!last) {
    <div class="train-separator"> + </div>
  }
</ng-template>

<div mat-dialog-title class="fx-row fx-justify-space-between fx-items-start">
  <h1 style="margin:0">Cambio classe</h1>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div>@if (load) {
  <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"
  ></mat-progress-bar>
}</div>
<mat-dialog-content>


  @for (train of solution.travelSolutions[0].trains; track train) {
    <div>
      <div class="fx-row fx-wrap fx-justify-start fx-items-center" style="gap:8px; margin-top:20px">
        <ng-container
          [ngTemplateOutlet]='trainNameTemplate'
          [ngTemplateOutletContext]='{last:true, train:train}'
        ></ng-container>
      </div>
      <h3>Seleziona servizio e offerta</h3>
      <trenitalia-other-solution [solution]="solution"
        [train]="train"
        [errors]="errors[train.id]"
      (custom-offer-select-price)="getEvent($event)"></trenitalia-other-solution>
    </div>
  }
  <!--<trenitalia-prices [travel-solution]="solution" (select-price)="getEvent($event)"></trenitalia-prices>-->
</mat-dialog-content>
<mat-dialog-actions align="end">
  <span class="tot">Totale: {{total | currency:'EUR'}}</span>
  <button mat-raised-button style="margin-left: 8px" (click)="updateTravel()">Aggiorna</button>
</mat-dialog-actions>